export default __webpack_public_path__ + "static/media/star_nexo.d31c5446.png";